import dayjs, { Dayjs } from "dayjs";
import type { InvoiceResponse } from "@Light/services/lightTypes";
import { useState } from "react";

export function paymentDays(
  now: Dayjs,
  invoice: InvoiceResponse | undefined,
): number {
  if (!invoice) {
    return 0;
  }
  return dayjs(invoice.payment_due_date).diff(now, "days");
}

export function usePaymentDays(invoice: InvoiceResponse | undefined) {
  // We do not want this "now" to change over the life of this component.
  const [now] = useState(() => dayjs());
  return paymentDays(now, invoice);
}

export function getNeedsPayment(invoice: InvoiceResponse | undefined): boolean {
  if (!invoice) {
    return false;
  }
  if (invoice.paid_at) {
    return false;
  }
  if (invoice.total_cents <= 0) {
    return false;
  }
  if (invoice.is_deferred) {
    return false;
  }
  if (invoice.rebill_invoice) {
    return false;
  }
  return true;
}

export function isPastDue(
  paymentDays: number,
  invoice: InvoiceResponse | undefined,
): boolean {
  if (!invoice) {
    return false;
  }
  if (!getNeedsPayment(invoice)) {
    return false;
  }
  if (paymentDays >= 0) {
    return false;
  }
  return true;
}

export function useIsPastDue(invoice: InvoiceResponse | undefined) {
  const paymentDays = usePaymentDays(invoice);
  return isPastDue(paymentDays, invoice);
}
